module.exports = __webpack_public_path__ + "img/placeholder.f7384dbe.jpg";